import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Autocomplete from "@mui/lab/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getUserWithdrawLimitList } from "../../redux/actions/getUserWithdrawLimitListAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { addOrUpdateUserWithdrawLimit } from "../../redux/actions/addOrUpdateUserWithdrawLimitAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { Tooltip } from "antd";
// import Tooltip from "@mui/material/Tooltip";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const UserUserWithdrawLimit = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [email, setEmail] = useState("");
	// const [mobile, setMobile] = useState("");
	const [customerOrMobName, setCustomerOrMobName] = useState("");
	const [page, setPage] = useState(0);
	const [open, setOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getUserWithdrawLimitStatus, setGetUserWithdrawLimitStatus] =
		useState(false);
	const [getUserWithdrawLimitResArray, setgetUserWithdrawLimitResArray] =
		useState([]);
	const [updateUserWithdrawalLimit, setUpdateUserWithdrawalLimit] =
		useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [customerId, setCustomerId] = useState("");
	const [limitId, setLimitId] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [editLevel, setEditLevel] = useState("");
	const [editDailyAmountLimit, setEditDailyAmountLimit] = useState("");
	const [editWeeklyAmountLimit, setEditWeeklyAmountLimit] = useState("");
	const [editMonthlyAmountLimit, setEditMonthlyAmountLimit] = useState("");
	const [editYearlyAmountLimit, setEditYearlyAmountLimit] = useState("");
	const [updateUserWithdrawalLimitArray, setUpdateUserWithdrawalLimitArray] =
		useState("");
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const classes = useStyles();
	const dispatch = useDispatch();

	const getUserWithdrawLimitRes = useSelector(
		({ getUserWithdrawLimitList }) => getUserWithdrawLimitList
	);

	const updateUserWithdrawLimitRes = useSelector(
		({ addOrUpdateUserWithdrawLimit }) => addOrUpdateUserWithdrawLimit
	);
	const getUsernameContactSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)
	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	// console.log(
	// 	updateUserWithdrawLimitRes,
	// 	"////////////////////////////////////////////////////////"
	// );

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "email") {
			setEmail(value);
		}
		if (name === "customerOrMobName") {

			//console.log("custttttNammmmee", customerOrMobName)
			setCustomerOrMobName(value)
			// onCustContactFunc(value)


		}

		// if (name === "mobile") {
		// 	// setMobile(value);
		// 	Util.verifyMobile(value) ? setMobile(value) : setMobile(mobile);
		// }

		if (name === "EditCurrency") {
			setEditCurrency(value);
		}

		if (name === "EditLevel") {
			setEditLevel(value);
		}

		if (name === "EditDailyAmountLimit") {
			// setEditDailyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditDailyAmountLimit(value)
				: setEditDailyAmountLimit(editDailyAmountLimit);
		}

		if (name === "EditWeeklyAmountLimit") {
			// setEditWeeklyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditWeeklyAmountLimit(value)
				: setEditWeeklyAmountLimit(editWeeklyAmountLimit);
		}

		if (name === "EditMonthlyAmountLimit") {
			// setEditMonthlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditMonthlyAmountLimit(value)
				: setEditMonthlyAmountLimit(editMonthlyAmountLimit);
		}

		if (name === "EditYearlyAmountLimit") {
			// setEditYearlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditYearlyAmountLimit(value)
				: setEditYearlyAmountLimit(editYearlyAmountLimit);
		}
	};

	const getUserWithdrawLimit = () => {
		setGetUserWithdrawLimitStatus(true);
		setIsLoading(true);
		const getUserWithdrawLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				email: email,
				// phoneNo: mobile
				phone:customerOrMobName.split("-")[0].substring(1),
			}
		};

		return dispatch(
			getUserWithdrawLimitList(getUserWithdrawLimitReq, authToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getUserWithdrawLimit();
		}
	}, [regenerateTokenRes.data.status]);

	const getUserWithdrawLimitStatusFunc = () => {
		if (getUserWithdrawLimitStatus) {
			if (getUserWithdrawLimitRes.data.status == "success") {
				setIsLoading(false);
				setgetUserWithdrawLimitResArray(
					[].concat(
						getUserWithdrawLimitRes.data.customerMasterDetailsKYCResponseVOList
					)
				);
			}
			if (getUserWithdrawLimitRes.data.status == "failed") {
				setIsLoading(false);
				setgetUserWithdrawLimitResArray(getUserWithdrawLimitRes.data);
				setNotificationOpen(true)
				
				if (
					getUserWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getUserWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getUserWithdrawLimitRes.data.status == "Failed") {
				setIsLoading(false);
				setgetUserWithdrawLimitResArray(getUserWithdrawLimitRes.data);
				if (
					getUserWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getUserWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getUserWithdrawLimitRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetUserWithdrawLimitResArray(getUserWithdrawLimitRes.data);
			}
		}
	};

	useEffect(() => {
		if (getUserWithdrawLimitRes.data.status == "success") {
			setPage(0);
		}
	}, [getUserWithdrawLimitRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const addOrUpdateUserWithdrawLimitFunc = () => {
		setOpen(false);
		setUpdateUserWithdrawalLimit(true);
		const addOrUpdateUserWithdrawLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId,
				currency: editCurrency,
				level: editLevel,
				dailyLimit: editDailyAmountLimit,
				weeklyLimit: editWeeklyAmountLimit,
				monthlyLimit: editMonthlyAmountLimit,
				yearlyLimit: editYearlyAmountLimit,
				limitId: limitId
			}
		};

		return dispatch(
			addOrUpdateUserWithdrawLimit(addOrUpdateUserWithdrawLimitReq, authToken)
		);
	};

	const editUserWithdrawLimit = (
		customerId,
		limitId,
		currency,
		level,
		daily,
		weekly,
		monthly,
		yearly
	) => {
		// console.log(
		// 	customerId,
		// 	limitId,
		// 	currency,
		// 	level,
		// 	daily,
		// 	weekly,
		// 	monthly,
		// 	yearly,
		// 	"////////////////////{{{{{{{{{{{{{{{}}}}}}}}}}}}}}}}}}}"
		// );
		setCustomerId(customerId);
		setLimitId(limitId);
		setEditCurrency(currency);
		setEditLevel(level);
		setEditDailyAmountLimit(daily);
		setEditWeeklyAmountLimit(weekly);
		setEditMonthlyAmountLimit(monthly);
		setEditYearlyAmountLimit(yearly);
		setOpen(true);
	};

	useEffect(() => {
		if (getUserWithdrawLimitStatus) {
			getUserWithdrawLimitStatusFunc();
		}
	}, [getUserWithdrawLimitRes.data.status]);

	const updateUserWithdrawLimitFunc = () => {
		if (updateUserWithdrawalLimit) {
			if (updateUserWithdrawLimitRes.data.status == "success") {
				setOpen(false);
				setUpdateUserWithdrawalLimitArray(updateUserWithdrawLimitRes.data);
				setNotificationOpen(true);
				getUserWithdrawLimit();
			}
			if (updateUserWithdrawLimitRes.data.status == "failed") {
				setOpen(false);
				setUpdateUserWithdrawalLimitArray(updateUserWithdrawLimitRes.data);
				setNotificationOpen(true);
				if (
					updateUserWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateUserWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateUserWithdrawLimitRes.data.status == "Failed") {
				setOpen(false);
				setUpdateUserWithdrawalLimitArray(updateUserWithdrawLimitRes.data);
				setNotificationOpen(true);
				if (
					updateUserWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateUserWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateUserWithdrawLimitFunc();
	}, [updateUserWithdrawLimitRes.data.status]);

	useEffect(() => {
		if (getUsernameContactSuggestionRes.data.status === "success") {
			//console.log("lissttt", getUsernameContactSuggestionRes.data.list)
		}
	}, [getUsernameContactSuggestionRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getUserContactReq = {
				actionCustomerMasterRequestVO: {
					customerMobileOrName: customerOrMobName,
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
			// console.log("userContact", getUserContactReq)
		}
	}, [regenerateTokenRes.data.status])

	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptions = options.filter(
			(option) =>
				option.mobile && option.mobile.includes(inputValue) ||
				option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptions.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "16px"
						}}
					>
						<Grid item md={4} sm={12} lg={5}></Grid>
						<Grid item md={4} sm={12} lg={3}>
							<NavLink to="/index/UWL-addwithdraw-limit">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Add New Withdraw Limit
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									// onClick={getWithdrawLimit}
								>
									Add New Withdraw Limit
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={4} sm={12} lg={3} style={{ marginLeft: "1rem" }}>
							<NavLink to="/index/UWL-addwithdrawal-count">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Add Withdrawal Count
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									// onClick={getWithdrawLimit}
								>
									Add New Withdraw Count
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								size="small"
								type="email"
								label="Email"
								fullWidth={true}
								variant="standard"
								color="primary"
								autoFocus={true}
								name="email"
								value={email || ""}
								style={{marginTop:"6px"}}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
						</Grid>
						{/* <Grid item sm={12} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Mobile Number"
								variant="standard"

								fullWidth={true}
								name="mobile"
								value={mobile || ""}
								onChange={handleChange}
							></TextField>
						</Grid> */}
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getUsernameContactSuggestionRes.data.list || [""]
									)}
									getOptionLabel={(option) => "+" + option.countryCode + " " + option.mobile + "-" + option.customerMobileOrName}
									filterOptions={filterOptions}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Mobile Number"
											style={{ marginTop: "3px" }}
											type="text"
											fullWidth
											{...params}
											value={customerOrMobName || ""}
											name="customerOrMobName"
											onBlur={handleChange}
											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}

										/>
									)}
								/>
							</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                  marginTop: "9px",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getUserWithdrawLimit}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getUserWithdrawLimit}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getUserWithdrawLimitResArray.length == undefined ||
				  !getUserWithdrawLimitStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									User Withdraw Limit Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									className="themeText "
									style={{ fontWeight: "700" }}
								>
									User Withdraw Limit Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Sr.No</TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Level
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Daily Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Weekly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Monthly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Yearly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getUserWithdrawLimitResArray &&
											[]
												.concat(getUserWithdrawLimitResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.limitId}>
														{/* <TableCell align="center">{index + 1}</TableCell> */}
														<TableCell align="center">
															{row.customerId}
														</TableCell>
														<TableCell align="center">{row.currency}</TableCell>
														<TableCell align="center">{row.level}</TableCell>
														<TableCell align="center">{row.daily}</TableCell>
														<TableCell align="center">{row.weekly}</TableCell>
														<TableCell align="center">{row.monthly}</TableCell>
														<TableCell align="center">{row.yearly}</TableCell>
														<TableCell align="center">
															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		editUserWithdrawLimit(
																			row.customerId,
																			row.limitId,
																			row.currency,
																			row.level,
																			row.daily,
																			row.weekly,
																			row.monthly,
																			row.yearly
																		)
																	}
																>
																	{/* Update */}
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getUserWithdrawLimitResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog className="themeText" open={open} onClose={handleClose}>
						<DialogTitle className="themeText">
							Update User Withdraw Limit
						</DialogTitle>
						<DialogContent>
							<TextField
								disabled
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Customer Id"
								fullWidth={true}
								name="CustomerId"
								value={customerId || ""}
								onChange={handleChange}
								variant="standard"
							></TextField>
							<TextField
								disabled
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								fullWidth={true}
								name="EditCurrency"
								variant="standard"
								value={editCurrency || ""}
								onChange={handleChange}
							>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>

							<TextField
								disabled
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Level"
								fullWidth={true}
								name="EditLevel"
								value={editLevel || ""}
								onChange={handleChange}
								variant="standard"

							>
								<MenuItem value="">Select Level</MenuItem>
								<MenuItem value="BASIC">BASIC</MenuItem>
								<MenuItem value="STANDARD">STANDARD</MenuItem>
								<MenuItem value="PREMIUM">PREMIUM</MenuItem>
								<MenuItem value="SUPREME">SUPREME</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Daily Amount Limit"
								value={editDailyAmountLimit || ""}
								name="EditDailyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								variant="standard"

							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Weekly Amount Limit"
								value={editWeeklyAmountLimit || ""}
								name="EditWeeklyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								variant="standard"

							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Monthly Amount Limit"
								value={editMonthlyAmountLimit || ""}
								name="EditMonthlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								variant="standard"

							></TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Yearly Amount Limit"
								value={editYearlyAmountLimit || ""}
								name="EditYearlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								variant="standard"

							></TextField>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateUserWithdrawLimitFunc}
							>
								Save
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={addOrUpdateUserWithdrawLimitFunc}
								endIcon={<SaveIcon />}
							>
								Save <SaveIcon />
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{updateUserWithdrawalLimitArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserWithdrawalLimitArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateUserWithdrawalLimitArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserWithdrawalLimitArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{updateUserWithdrawalLimitArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateUserWithdrawalLimitArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

{getUserWithdrawLimitResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getUserWithdrawLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default UserUserWithdrawLimit;
